import { useCallback, useState } from 'react';
import { useAddProductSourceMutation } from '../entities/project/api/projectApi';

export interface ManualSourceDraft {
    url: string;
    price: number;
    title?: string;
}

const FALLBACK_ERROR = 'Не удалось добавить источник';

const messageOf = (error: unknown): string => {
    const data = (error as { data?: { message?: unknown } })?.data;
    const message = data?.message;

    if (typeof message === 'string' && message) return message;
    if (Array.isArray(message) && typeof message[0] === 'string') return message[0];
    return FALLBACK_ERROR;
};

export const useManualOffers = (reportId: string, productId: string) => {
    const [addSource] = useAddProductSourceMutation();
    const [saving, setSaving] = useState(false);
    const add = useCallback(
        async (draft: ManualSourceDraft): Promise<string | null> => {
            setSaving(true);
            try {
                await addSource({ productId, reportId, ...draft }).unwrap();
                return null;
            } catch (error) {
                return messageOf(error);
            } finally {
                setSaving(false);
            }
        },
        [addSource, productId, reportId],
    );

    return { add, saving };
};